// Module
var code = "<massia-form form=\"true\" label=\"{{ $ctrl.caracteristique.libelle }}\" label-class=\"{{$ctrl.isObligatoire ? 'mandatory-field' : ''}}\"> <div ac-datepicker ng-model=\"$ctrl.model.value\" ac-datepicker-disabled=\"$ctrl.lecture\"></div> </massia-form> ";
// Exports
module.exports = code;